import {
  TOGGLE_SEARCH_EMPLOYEE_POPUP,
  SET_SELECTED_EMPLOYEE_LIST,
  SET_PREVIEW_EMPLOYEE,
  SET_PREVIEW_EMPLOYEE_SUCCESS,
  API_ERROR,
  SET_EMPLOYEE_DETAIL,
  SET_EMPLOYEE_DETAIL_SUCCESS,
  SET_EMPLOYEE_EXTERNAL_PROFILE_SUCCESS,
  SET_EMPLOYEE_EXTERNAL_PROFILE,
  SET_EMPLOYEE_ALARM_SETTING,
  SET_EMPLOYEE_ALARM_SETTING_SUCCESS,
} from "./actionTypes";

export const toggleSearchEmployeePopup = (isOpen) => ({
  type: TOGGLE_SEARCH_EMPLOYEE_POPUP,
  payload: isOpen,
});
export const setSelectedEmployeeList = (list) => ({
  type: SET_SELECTED_EMPLOYEE_LIST,
  payload: list,
});

export const getEmployee = (params) => ({
  type: SET_PREVIEW_EMPLOYEE,
  payload: params,
});

export const getEmployeeSuccess = (employeeIdx) => {
  return {
    type: SET_PREVIEW_EMPLOYEE_SUCCESS,
    payload: employeeIdx,
  };
};

export const getEmployeeDetail = (params) => ({
  type: SET_EMPLOYEE_DETAIL,
  payload: params,
});

export const getEmployeeDetailSuccess = (employeeIdx) => {
  return {
    type: SET_EMPLOYEE_DETAIL_SUCCESS,
    payload: employeeIdx,
  };
};

export const getEmployeeExternalProfile = (params) => ({
  type: SET_EMPLOYEE_EXTERNAL_PROFILE,
  payload: params,
});

export const getEmployeeExternalProfileSuccess = (employeeIdx) => {
  return {
    type: SET_EMPLOYEE_EXTERNAL_PROFILE_SUCCESS,
    payload: employeeIdx,
  };
};
export const getEmployeeAlarmSetting = (params) => ({
  type: SET_EMPLOYEE_ALARM_SETTING,
  payload: params,
});

export const getEmployeeAlarmSettingSuccess = (employeeIdx) => {
  return {
    type: SET_EMPLOYEE_ALARM_SETTING_SUCCESS,
    payload: employeeIdx,
  };
};


export const apiError = (error) => ({
  type: API_ERROR,
  payload: error,
});